import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  card: {
    backgroundColor: colors.neutral.white,
    padding: '1.6rem 3.2rem',
    boxSizing: 'border-box',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'space-between',

    '&:not(:last-of-type)': {
      marginBottom: '2.4rem',
    },
  },
  filesStepCard: {
    borderLeft: `1rem solid ${colors.green[600]}`,
    paddingLeft: '2.2rem',
    minHeight: '10.8rem',
    alignItems: 'center',
  },
  title: {
    font: {
      size: '2rem',
      lineHeight: '2.8rem',
      weight: 500,
    },
    letterSpacing: '0.02rem',
    margin: {
      bottom: '0.8rem',
    },
  },
  rightSection: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end' },
  filesStepRightSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  text: {
    maxWidth: '40rem',
    margin: 0,
    font: { size: '1.4rem', lineHeight: '2rem' },
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
  },
  actionButton: {
    marginBottom: '1.2rem',
  },

  // Card statuses
  completedCardWrapper: { color: colors.green[600], display: 'inline-flex', alignItems: 'center' },
  cardStatusText: {
    display: 'inline-flex',
    alignItems: 'center',
    font: {
      size: '1.2rem',
    },
  },
  completedIcon: { marginRight: '0.4rem' },
  readyToBeginStatusText: { color: colors.blue[600] },
  inProgressStatusText: { color: colors.orange[500] },
};

const createStyles = createUseStyles(styles);

export { createStyles };
